<!-- eslint-disable vue/no-mutating-props -->
<script setup>

import placeFieldVue from '@/components/AdvancedFields/placeField.vue'
import { useLocale } from 'vuetify'
const { t } = useLocale()

</script>
<template>
    <div class="w-100 overflow-hidden">
        <v-container class="z-index-5 position-relative py-lg-5" style="max-width: 1200px;" :class="data.class">
            <v-row>
                <v-col cols="12">
                    <h3 class="text-h4 mb-5 text-md-h3" data-aos="fade-right" v-html="data.title"></h3>
                    <h4 class="text-h6 text-md-h5" data-aos="fade-right"  v-html="data.sub_title"></h4>
                </v-col>
            </v-row>
        </v-container>
        <v-img 
            lazy 
            v-if="data.has_image"
            cover 
            :alt="data.title"
            min-height="340"
            max-height="50vh"
            :position="data.image_position_x+' '+data.image_position_y"
            class="mt-n16 mx-auto"
            :lazy-src="data.image.sizes.medium" 
            :src="data.image.sizes.full"
            width="100%"
            gradient="to bottom, rgba(0,0,0,1), rgba(0,0,0,0), rgba(0,0,0,0), rgba(0,0,0,0), rgba(0,0,0,1)"
        >
        </v-img>
        <div v-else class="py-10"></div>
        <div class="py-5 py-md-3"></div>
        <v-container class="overtop-100 z-index-10"  data-aos="fade-up">
            <v-form ref="quoteRequest" v-model="valid">
                <v-row>
                    
                    

                    <v-col cols="12">
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-text-field 
                                    :label="`${t('attributes.firstName.label')} *`"
                                    required
                                    :rules=" [rules.required] "
                                    name="firstName"
                                    hide-details
                                    role="firstName"
                                    autocomplete
                                    variant="solo-filled"
                                    class="font-weight-bold"
                                    v-model="data.form.firstName">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field 
                                    :label="`${t('attributes.lastName.label')} *`"
                                    required
                                    :rules=" [rules.required] "
                                    name="lastName"
                                    hide-details
                                    role="lastName"
                                    autocomplete
                                    variant="solo-filled"
                                    class="font-weight-bold"
                                    v-model="data.form.lastName">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <placeFieldVue
                                    @update="setResidentialCity($event)"
                                    label="attributes.city_of_residence.label"
                                    :allCountries="true"
                                ></placeFieldVue>
                                <!-- <v-autocomplete
                                    :items="countries"
                                    item-value="iso"
                                    :item-title="item => `${item.country} (${item.iso})`"
                                    hide-details
                                    variant="solo-filled"
                                    :rules="[rules.required]"
                                    @update:modelValue="checkPrefix($event)"
                                    color="primary"
                                    :label="`${t('attributes.nation.label')} *`"
                                    class="font-weight-bold"
                                    v-model="data.form.country">
                                </v-autocomplete> -->
                            </v-col>
                            <!-- <v-col cols="12" md="6" :key="minAge">

                                <v-text-field 
                                    hide-details
                                    variant="outlined" 
                                    class="bg-search calendar-input"
                                    name="dateOfBirth" 
                                    :label="t('attributes.date_of_birth.label')"
                                    type="date" 
                                    required
                                    :min="minAge"
                                    :max="maxAge"
                                    v-model="data.form.dateOfBirth">
                                </v-text-field>

                            </v-col> -->
                           
                            <v-col cols="12" md="4">
                                <v-text-field 
                                    :label="`${t('attributes.email.label')} *`"
                                    hide-details
                                    required
                                    :rules=" [rules.required, rules.email] "
                                    name="email"
                                    role="email"
                                    autocomplete
                                    variant="solo-filled"
                                    class="font-weight-bold"
                                    v-model="data.form.email">
                                </v-text-field>
                            </v-col>
                            <v-col cols="4" md="4">
                                <v-autocomplete
                                    :items="countries"
                                    item-value="prefix"
                                    :item-title="item => `${item.country} (${item.prefix})`"
                                    hide-details
                                    variant="solo-filled"
                                    :rules="[rules.required]"
                                    @update:modelValue="checkNation($event)"
                                    color="primary"
                                    :label="`${t('attributes.phone_prefix.label')} *`"
                                    class="font-weight-bold"
                                    v-model="data.form.phone_prefix">
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="8" md="4">
                                <v-text-field 
                                    :label="`${t('attributes.phone.label')} *`"
                                    required
                                    :rules=" [rules.required, rules.phone] "
                                    name="phone"
                                    role="phone"
                                    hide-details
                                    autocomplete
                                    variant="solo-filled"
                                    class="font-weight-bold"
                                    v-model="data.form.phone">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" md="4" v-if="data.form.scope == 'medium-term-quotations'">
                                <placeFieldVue
                                    @update="setLocationStart(data.form.rental, $event)"
                                    label="attributes.location_start.label"
                                ></placeFieldVue>
                                <!-- <v-text-field 
                                    :label="`${t('attributes.city.label')} *`"
                                    required
                                    :rules=" [rules.required] "
                                    name="city"
                                    role="city"
                                    autocomplete
                                    hide-details
                                    variant="solo-filled"
                                    class="font-weight-bold"
                                    v-model="data.form.city">
                                </v-text-field> -->
                            </v-col>
                            <!-- <v-col cols="12" md="6" v-if="data.form.scope == 'medium-term-quotations'">
                                <v-text-field 
                                    :label="`${t('attributes.additional-info.label')} *`"
                                    hide-details
                                    name="message"
                                    role="message"
                                    autocomplete
                                    variant="solo-filled"
                                    class="font-weight-bold"
                                    v-model="data.form.message">
                                </v-text-field>
                            </v-col> -->

                            <v-col cols="12" md="4" v-if="data.form.scope == 'short-term-quotations'">
                        <placeFieldVue
                            @update="setLocationStart(data.form.rental, $event)"
                            label="attributes.location_start.label"
                        ></placeFieldVue>
                    </v-col>
                    <v-col cols="12" md="4" v-if="data.form.scope == 'short-term-quotations'">
                        <placeFieldVue
                            @update="setLocationEnd(data.form.rental, $event)"
                            label="attributes.location_end.label"
                        ></placeFieldVue>
                    </v-col>

                    <v-col cols="12" md="4" v-if="data.form.scope == 'short-term-quotations'">
                        <range-date-picker 
                            v-if="data.form.rental.start && data.form.rental.end"
                            @update="setDates(data.form.rental, $event)"
                            :preValue="data.form.rental"
                            :label="`${t('attributes.date_range.label')} *`"
                            class="bg-search"
                            hide-details
                            :min="min"
                            :max="max"
                            >
                        </range-date-picker>
                    </v-col>
                      
                    <v-col v-if="data.form.scope == 'medium-term-quotations'">
                        <date-picker 
                            v-if="data.form.rental.start"
                            @update="setDate(data.form.rental, $event)"
                            :value="data.form.rental.start.date"
                            :label="`${t('attributes.rent-start.label')} *`"
                            hide-details
                            class="bg-search font-weight-bold"
                            required 
                            >
                        </date-picker>
                    </v-col>
                    <v-col v-if="data.form.scope == 'medium-term-quotations'">
                        <v-select
                            :label="`${t('attributes.rent-mounths.label')} *`"
                            hide-details
                            required
                            class="bg-search font-weight-bold"
                            :rules="[rules.required]"
                            :items="months"
                            item-title="text"
                            item-value="value"
                            variant="solo-filled"
                            v-model="data.form.rental.duration"
                        >
                        </v-select>
                    </v-col>
                       
                    

                    <v-col cols="12" v-if="showcarselect">
                        <v-row>
                            <v-col cols="12" md="4"> 
                                <v-select
                                    :label="`${t('attributes.car_types.label')}`"
                                    required
                                    return-object
                                    hide-details
                                    :items="types"
                                    item-value="label"
                                    clearable
                                    item-title="label"
                                    variant="solo-filled"
                                    class="font-weight-bold"
                                    v-model="data.form.car.type"
                                >
                                </v-select>
                            </v-col>
                            <v-col cols="12" md="4"> 
                                <v-select
                                    :label="`${t('attributes.car_brand.label')}`"
                                    class="font-weight-bold"
                                    return-object
                                    hide-details
                                    :items="brands"
                                    item-value="name"
                                    clearable
                                    item-title="name"
                                    variant="solo-filled"
                                    v-model="data.form.car.brand"
                                >
                                </v-select>
                            </v-col>
                            <v-col cols="12" md="4"> 
                                <v-select
                                    :label="`${t('attributes.car_models.label')} *`"
                                    
                                    hide-details
                                    return-object
                                    :items="filteredModels(models)"
                                    :rules="[rules.required]"
                                    clearable
                                    :item-value="item => `${item.brand} - ${item.name}`"
                                    :item-title="item => `${item.brand} - ${item.name}`"
                                    variant="solo-filled"
                                    class="font-weight-bold"
                                    v-model="data.form.car.model"
                                >
                                </v-select>
                            </v-col>
                            <v-col cols="12">
                                <v-textarea v-model="data.form.message" :label="t('attributes.notesMessage.label')" :rows="2" hide-details variant="solo-filled" class="font-weight-bold" />
                                <!-- <v-select
                                    :label="`${t('attributes.car_models.label')} *`"
                                    
                                    hide-details
                                    return-object
                                    :items="filteredModels(models)"
                                    :rules="[rules.required]"
                                    clearable
                                    :item-value="item => `${item.brand} - ${item.name}`"
                                    :item-title="item => `${item.brand} - ${item.name}`"
                                    variant="solo-filled"
                                    class="font-weight-bold"
                                    v-model="data.form.car.model"
                                >
                                </v-select> -->
                            </v-col>
                        </v-row>
                    </v-col>

                            <v-col cols="12" >
                                <v-checkbox 
                                    v-model="data.form.privacy"
                                    name="privacy"
                                    :rules="[rules.required]"
                                    required
                                >
                                    <template v-slot:label>
                                        <div>
                                            {{ t('attributes.privacy.label') }}
                                            <br>
                                            <a @click.stop :href="t('attributes.privacy.url')" target="_blank" rel="noopener noreferrer">
                                                {{ t('attributes.privacy.text_url') }}
                                            </a>
                                        </div>
                                    </template>
                                </v-checkbox>
                            </v-col>
                            
                        </v-row>
                    </v-col>
                    <v-col cols="10" class="mx-auto">
                        <v-btn 
                            :loading="loading"
                            :disabled="loading"
                            @click="submit" 
                            rounded="pill"
                            size="large"
                             block 
                             color="secondary">
                            <span class="font-weight-bold">
                                {{t('commons.request-quotation')}}
                            </span>
                        </v-btn>
                    </v-col>
                    <v-col cols="12" class="mx-auto d-none" >

                        <dialog-simple :remoteOpener="opener" width="600" :title="''">
                            <v-container v-if="message">
                                    <v-alert 
                                        :icon="(success) ? 'mdi-check' : 'mdi-alert'"
                                        :color="(success) ? 'white' : 'error'"
                                        border="start" 
                                        variant="outlined"
                                       >
                                        <h2 v-if="success">{{ t(message+'.'+data.form.scope+'.title') }}</h2>
                                        <p v-if="success">{{ t(message+'.'+data.form.scope+'.text') }}</p>
                                        <h2 v-if="!success" >{{ message }}</h2>
                                        <p v-if="!success" >{{ errors }}</p>
                                    </v-alert>
                            </v-container>
                        </dialog-simple>

                    </v-col>
                </v-row>
            </v-form>
        </v-container>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import {validateEmail, validatePhone } from "@/plugins/validationFunctions.js"
import rangeDatePicker from '@/components/AdvancedFields/rangeDatePicker.vue'
import datePicker from '@/components/AdvancedFields/datePicker.vue'
import countries from "@/plugins/countries.json"

export default {
    name: 'RequestQuoteComponent',
    components:{
        rangeDatePicker,
        datePicker
    },
    computed: {
        ...mapGetters({
            loading: 'loading/loading',
            success: 'driveLeads/success',
            account: 'driveAuth/account',
            isAuthenticated: 'driveAuth/isAuthenticated',
            message: 'driveLeads/message',
            errors: 'driveLeads/errors',
            actions: 'driveLeads/actions',
            brands: 'carsDrive/brands',
            types: 'carsDrive/types',
            models: 'carsDrive/models',
        }),
    },
    props:{
        data:{
            required: true,
            type: Object,
        }
    },
    watch: {
        'data.form.car.model': {
            handler(newValue) {
                this.stopTypeWatching = true
                const foundModel = this.models.find(m => m.id === newValue?.id)
                this.data.form.car.type = this.types.find(t => t.id === foundModel?.typeId) || null
                if (this.stopBrandWatching) {
                    this.stopBrandWatching = false
                    return
                }
                this.data.form.car.brand = this.brands.find(b => b.id === foundModel?.brandId) || null
            },
            deep: true
        },
        'data.form.car.brand': {
            handler(newValue) {
                const brandId = newValue?.id
                const model = this.data?.form?.car?.model

                if (model) {
                    const foundModel = this.models.find(m => m.id === model.id)
                    const foundTypeId = foundModel?.typeId
                    const foundTpye = this.types.find(t => t.id === foundTypeId)
                    this.data.form.car.type = foundTpye || null

                    if (foundModel?.brandId !== brandId) {
                        this.stopBrandWatching = true
                        this.data.form.car.model = null
                        this.data.form.car.type = null
                    }
                }
            },
            deep: true
        },
        'data.form.car.type': {
            handler() {
                if (this.stopTypeWatching) {
                    this.stopTypeWatching = false
                    return
                }
                this.data.form.car.model = null
                this.data.form.car.brand = null
            },
            deep: true
        },
    },
    data: () => ({
        stopBrandWatching: false,
        stopTypeWatching: false,
        valid: false,
        showcarselect: true,
        countries: countries,
        closer: false,
        opener: false,
        max: null,
        min: null,
        minAge: "1900-01-01",
        maxAge: "2006-01-01",
        months: [],
        rules: {
            email: value => validateEmail(value) || 'attributes.email.validation.email',
            phone: value => validatePhone(value) || 'attributes.phone.validation.phone',
            required: value => !!value || 'attributes.generic.validation.required',
        },
    }),
    mounted(){
        this.months = this.createMonthArray()
        this.showcarselect = (this.data.showcarselect == undefined) ? true :  this.data.showcarselect
        this.rules = {
            email: value => validateEmail(value) || this.translate('attributes.email.validation.email'),
            phone: value => validatePhone(value) || this.translate('attributes.phone.validation.phone'),
            required: value => !!value || this.translate('attributes.generic.validation.required'),
        }

        this.min = this.$moment().add(1,'days').format('YYYY-MM-DD');
        this.max = this.$moment().add(1,'year').format('YYYY-MM-DD');
        
        this.maxAge = this.$moment().subtract(18,'year').format('YYYY-MM-DD')
        this.minAge = this.$moment().subtract(99,'year').format('YYYY-MM-DD')

        // eslint-disable-next-line vue/no-mutating-props
        this.data.form.fromUrl = location.href
        // eslint-disable-next-line vue/no-mutating-props
        this.data.form.phone_prefix = null;

        if(this.data.form.scope == "medium-term-quotations"){
            // eslint-disable-next-line vue/no-mutating-props
            delete this.data.form.rental.end
            // eslint-disable-next-line vue/no-mutating-props
            delete this.data.form.address
            // eslint-disable-next-line vue/no-mutating-props
            this.data.form.rental = {
                start: {
                    date: null
                },
                duration: null,
            }
            
        }else{
            // eslint-disable-next-line vue/no-mutating-props
            // delete this.data.form.rental.duration
            // eslint-disable-next-line vue/no-mutating-props
            // delete this.data.form.city
            // eslint-disable-next-line vue/no-mutating-props
            delete this.data.form.address
            // eslint-disable-next-line vue/no-mutating-props
            // delete this.data.form.message
            // eslint-disable-next-line vue/no-mutating-props
            this.data.form.rental = {
                start: {
                    date: null
                },
                end: {
                    date: null
                }
            }
        }

        if(this.isAuthenticated){
            if(this.account && !this.account.role){
                this.checkSameKeys( this.data.form, this.account)
            }
        }

       
           this.$store.dispatch('carsDrive/getBrands', {online:true, availableOnly: true})
           this.$store.dispatch('carsDrive/getTypes')
           this.$store.dispatch('carsDrive/getModels', {online:true, availableOnly: true})
        


        if(this.data.form.car.type_id){
            // this.data.form.car.type.id = this.types.filter( i => i.id == this.data.form.car.type_id )[0]
        }
        if(this.data.form.car.brand_id){
            // this.data.form.car.brand.id = this.brands.filter( i => i.id == this.data.form.car.brand_id )[0]
        }
        if(this.data.form.car.model_id){
            // this.data.form.car.model.id = this.models.filter( i => i.id == this.data.form.car.model_id )[0]
        }

        this.resetDriveLeads()

    },
    methods:{
        checkPrefix(event){
            if(this.data.form.phone_prefix == null){
                var country = this.countries.filter(x => x.iso == event)[0]
                this.data.form.phone_prefix = country.prefix
            }
        },
        checkNation(event){
            var country = this.countries.filter(x => x.prefix == event)[0]
            this.data.form.country = country.iso
        },
        createMonthArray(){
            let months = [];

            for (let i = 1; i <= 12; i++) {
                const monthText = i +' '+  this.translate('attributes.months.label')
                months.push({ 
                    text: monthText, 
                    value: i 
                });
            }

            return months
        },
        resetDriveLeads(){
            this.$store.dispatch('driveLeads/resetErrors')
        },
        translate(string){
            return this.$vuetify.locale.t(string)
        },
        setDate(element, val){
            element.start.date = val
        },
        setDates(element, val){
            element.start.date = val.startDate
            element.end.date = val.endDate
        },
        setDateOfBirth(val){
            this.data.form.dateOfBirth = val
        },
        setResidentialCity(location) {
            this.data.form.city = location?.description
        },
        setLocationStart(element, location){
            element.start = {... element.start, ...location}
        },
        setLocationEnd(element, location){
            element.end = {... element.end, ...location}
        },
        checkSameKeys(form, account){
            Object.keys(form).forEach((element) => {
                if(account[element]){
                    form[element] = account[element]
                }
            });
        },
        filteredModels(array){

            let types = [];
            let brands = [];

            if(this.data.form.car.type){
                types = [this.data.form.car.type.id];
            }
            if(this.data.form.car.brand){
                brands = [this.data.form.car.brand.id];
            }

            if(types.length){
                array = array.filter( i => types.includes( i.typeId ) );
            }
            if(brands.length){
                array = array.filter( i => brands.includes( i.brandId ) );
            }

            return array
        },
        scrollToFirstInvalidInput() {
            // Get all invalid input elements.  This assumes you're using a validation library
            // that adds a class like "is-invalid" or similar to invalid inputs.  Adjust
            // the selector as needed.
            const invalidInputs = document.querySelectorAll('.v-input--error');

            if (invalidInputs.length > 0) {
                // Scroll to the first invalid input.
                invalidInputs[0].scrollIntoView({
                    behavior: 'smooth', // Optional: for smooth scrolling
                    block: 'center'   // Optional: scrolls the element to the center of the viewport
                });

                // Optionally, focus on the invalid input for better UX.
                invalidInputs[0].focus();
            }
        },
        async validate () {
            const { valid } = await this.$refs.quoteRequest.validate()

            return valid;
        },
        reset () {
            this.$refs.quoteRequest.reset()
        },
        resetValidation () {
            this.$refs.quoteRequest.resetValidation()
        },
        async submit(){
            try {
                this.$store.dispatch('loading/set',true)
                this.resetValidation();
                this.resetDriveLeads();
                this.opener = false;
                let action = this.actions[this.data.form.scope]

                if( await this.validate() ){

                    let payload = JSON.parse(JSON.stringify(this.data.form));

                    payload.car = {
                        typeId: (this.data?.form?.car?.type) ? this.data.form.car.type.id : null,
                        brandId: (this.data?.form?.car?.brand) ? this.data.form.car.brand.id : null,
                        modelId: (this.data.form.car.model) ? this.data.form.car.model.id : null,
                    }

                    payload.phone = this.data.form.phone_prefix+''+this.data.form.phone
                    payload.language = localStorage.getItem('locale') || 'en';


                    this.$gtm.trackEvent({
                        event: 'request_quote',
                        data: payload,
                    })

                    await this.$store.dispatch('driveLeads/'+action, payload).then(()=>{
                        this.reset();
                        this.opener = true;
                        if(this.isAuthenticated){
                            if(this.account && !this.account.role){
                                this.checkSameKeys( this.data.form, this.account)
                            }
                        }
                        this.resetValidation();
                    })
                }else{
                    this.scrollToFirstInvalidInput()
                }
            } catch (error) {
                console.error('Error during form submission:', error);
            } finally {
                this.$store.dispatch('loading/set',false)
            }
        },
    }
}
</script>


<style scoped>
.overtop-100{
    position: relative;
    top: -100px;
    margin-bottom: -100px;
}
</style>